import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'
import ServiceSetImportTemplate from '../../../components/5templates/ServiceSetImportTemplate'

const ImportServiceSet = () => {
    const navigate = useNavigate()

    const onNext = () => {
        navigate('/addClient/location')
    }

    const onPrev = () => {
        navigate('/adminDashboard')
    }

    return(
        <Box sx={{ marginLeft: '60px', padding: '20px', width: '100%' }}>
            <ServiceSetImportTemplate
                onNext={onNext}
                onPrev={onPrev}
            />
        </Box>
    )
}

export default ImportServiceSet
